














import createForm from '@/activeForms/wiki/createNode'
import Vue, {VueConstructor} from 'vue'
export default (Vue as VueConstructor<Vue & {
  $refs: {
    form: { reset: () => void },
  }
}>).extend({
  data () {
    return {
      data: {},
      createForm
    }
  },
  methods: {
    onCreated () {
      this.$message({
          // @ts-ignore
        message: this.$t('wiki.added_successfully'),
        type: 'success'
      });
      this.data = {}
      this.$refs.form.reset()
    },
    onError () {
      this.$message({
          // @ts-ignore
        message: this.$t('wiki.create_error'),
        type: 'error'
      });
    }
  }
})
